module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-3-9e388fd9bd91a0035369c899f925334a.png";